import orderBy from 'lodash/orderBy';
import { DateTime } from 'luxon';

interface UserFieldsNeededForLatestActivated {
  createdAt: Date | DateTime; // Since we call this from both the client and the server. Not the tightest abstraction, honestly.
  loginActivated: boolean;
}

export function getLatestUserActivatedPreferred<
  T extends UserFieldsNeededForLatestActivated,
>(users: Array<T>): T {
  const sortedUsers = orderBy(users, (user) => user.createdAt, 'desc');
  const activatedUsers = sortedUsers.filter((user) => user.loginActivated);

  // if there are no activated users, use the latest created user
  const user = activatedUsers.length > 0 ? activatedUsers[0] : sortedUsers[0];
  return user;
}

/**
 * Is an authenticated user a customer?
 */
export function isAuthenticatedUserACustomer({
  loginAsUserId,
  isWatershedEmployee,
}: {
  loginAsUserId?: string;
  isWatershedEmployee: boolean;
}): boolean {
  return !loginAsUserId && !isWatershedEmployee;
}
